// File: src/config/menu.ts
import type { ComponentType } from 'react'
import { LayoutDashboard, Building2, ClipboardCheck, Stethoscope, GraduationCap, Users, FileText, LibrarySparkles, BookOpen } from '../components/icons'
import { FileInput, Library, UserCircle, Workflow } from 'lucide-react'

export type TabKey =
  | 'dashboard'
  | 'adminpanel'
  | 'fortbildungsbibliothek'
  | 'vorlagenbibliothek'
  | 'qmvorlagen'
  | 'qmhimport'
  | 'organisation'
  | 'dokumente'
  | 'prozesse'
  | 'md'
  | 'iso9001'
  | 'iso15224'
  | 'va'
  | 'fortbildungen'
  | 'pflegevisite'
  | 'mitarbeitende'
  | 'qmhandbuch'
  | 'wiki'
  | 'beschwerdemanagement'
  | 'wissenswertes'
  | 'profil'

export type MenuItem = { id: TabKey; title: string; icon: ComponentType<React.SVGProps<SVGSVGElement>> }

export const menuItems: MenuItem[] = [
  { id: 'dashboard', title: 'Dashboard', icon: LayoutDashboard },
  { id: 'adminpanel', title: 'Organisationen', icon: Building2 },
  { id: 'fortbildungsbibliothek', title: 'Fortbildungsbibliothek', icon: LibrarySparkles },
  { id: 'vorlagenbibliothek', title: 'Vorlagenbibliothek', icon: FileText },
  { id: 'qmvorlagen', title: 'QM Vorlagen', icon: LibrarySparkles },
  { id: 'qmhimport', title: 'QMH-Import', icon: FileInput },
  { id: 'organisation', title: 'Organisation', icon: Building2 },
  { id: 'dokumente', title: 'Dokumente', icon: FileText },
  { id: 'md', title: 'MD Checkliste', icon: ClipboardCheck },
  { id: 'iso9001', title: 'ISO 9001', icon: ClipboardCheck },
  { id: 'iso15224', title: 'ISO 15224', icon: ClipboardCheck },
  { id: 'pflegevisite', title: 'Pflegevisite', icon: Stethoscope },
  { id: 'fortbildungen', title: 'Fortbildung', icon: GraduationCap },
  { id: 'mitarbeitende', title: 'Mitarbeitende', icon: Users },
  { id: 'va', title: 'Verfahrensanweisungen', icon: FileText },
  { id: 'qmhandbuch', title: 'QM Handbuch', icon: BookOpen },
  { id: 'prozesse', title: 'Prozesse', icon: Workflow },
  { id: 'wiki', title: 'Unternehmenswiki', icon: Library },
  { id: 'beschwerdemanagement', title: 'Verbesserungsliste', icon: FileText },
  { id: 'wissenswertes', title: 'Wissenswertes QM', icon: FileText },
  { id: 'profil', title: 'Profil', icon: UserCircle },
]
